export enum Role {
    Admin = 'APP_AUDIT_GATE_ADMIN',
    Auditor = 'APP_AUDIT_GATE_AUDITOR',
}

export const ROLE_MAP: Record<Role, string> = {
    [Role.Admin]: 'Admin',
    [Role.Auditor]: 'Auditor',
};
